export enum Variant {
   DEFAULT = "default",
   LARGE = "lg",
}

export enum CardSize {
   SMALL = "small",
   MEDIUM = "medium",
   LARGE = "large",
}

export enum ButtonVariant {
   DEFAULT = "default",
   SMALL = "sm",
   LARGE = "lg",
}

export enum ColorVariant {
   JET_BLACK = "--jet-black",
   WHITE = "--white",
   HONOLULU_BLUE_DARK = "--honolulu-blue-dark",
   HONOLULU_BLUE = "--honolulu-blue",
   HONOLULU_BLUE_LIGHT = "--honolulu-blue-light",
   COOL_GRAY = "--cool-gray",
   SILVER = "--silver",
   GRAY = "--gray",
   GUNMETAL = "--gunmetal",
   CERISE = "--cerise",
   CRIMSON = "--crimson",
   ORANGE = "--orange",
   LEMON = "--lemon",
   AMETHYST = "--amethyst",
   MUNSELL = "--munsell",
   PINK = "--pink",
   MENTHOL = "--menthol",
   LAVENDER = "--lavender",
   OUTER_SPACE = "--outer-space",
}

export enum Token {
   AUTH_TOKEN = "token",
   TENANT_ID = "tenantId",
   CUSTOMER_ID = "customerId",
   FACILITY_ID = "facilityId",
   LOCATION_VISIBILITY = "locationVisibility",
   CELL_CARD_SIZE = "cellCardSize",
   SMARTWATCH_CARD_SIZE = "smartwatchCardSize",
   FACILITY_LEVEL_SELECTORS = "facilityLevelSelectors",
   TEST_ALARM_TRIGGER_ENABLED = "testAlarmTriggerEnabled",
   COLLAPSED_LOCATIONS = "collapsedLocations",
}

export enum QueryParameter {
   ACTIVATION = "activate",
   RECOVERY = "recovery",
   CODE = "code",
   STATE = "state",
}

export enum TypefaceColors {
   WHITE = "#ffffff",
   GUNMETAL = "#242f38",
}
